import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=1efd945e&scoped=true&"
var script = {}
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=1efd945e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd945e",
  null
  
)

export default component.exports